import { render, staticRenderFns } from "./NoAccessGame.vue?vue&type=template&id=b204c030&"
import script from "./NoAccessGame.vue?vue&type=script&lang=js&"
export * from "./NoAccessGame.vue?vue&type=script&lang=js&"
import style0 from "./NoAccessGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports